// extracted by mini-css-extract-plugin
export default {"cardBackground":"DraftLoading_cardBackground__VGmfc"};